import { useContext, useState } from "react";
import { BillingInformationContext } from "../../../Account/BillingInformation/BillingInformationContext";
import { usePaymentForm } from "../../../Shared/components/PaymentForm/usePaymentForm";
import { calculateOrderTotal, handleConfirmClick } from "./PaymentDialog-utils";
import { LoadingText } from "./PaymentDialog-types";
import { useLogging } from "../../../Shared/hooks/useLogging/useLogging";
import { useModal } from "../../../Shared/components/Modal";
export const usePaymentDialog = () => {
    var _a;
    const [isLoading, setIsLoading] = useState(LoadingText.DEFAULT);
    const [isErrorState, setIsErrorState] = useState(undefined);
    const [paymentComplete, setPaymentComplete] = useState(false);
    const { datadogLog } = useLogging();
    const { showModal } = useModal();
    const { paymentIntentId, paymentProcessor, resetContext: resetBillingInfoContext, } = useContext(BillingInformationContext);
    const { setIsFormSubmitted, resetContext: resetPaymentFormContext, paymentMethod, giftCard, setBalance, balance, } = usePaymentForm();
    const clearState = () => {
        setIsLoading(LoadingText.DEFAULT);
        setIsErrorState(undefined);
        setPaymentComplete(false);
        setIsFormSubmitted(false);
        resetBillingInfoContext();
        resetPaymentFormContext();
    };
    // Object containing helper functions and state setters required for payment actions.
    // This object centralizes all dependencies, making it easier to pass into functions.
    const actionHelpers = {
        setIsErrorState,
        setIsLoading,
        setIsFormSubmitted,
        setBalance,
        datadogLog,
        setPaymentComplete,
        clearState,
        showModal,
    };
    const giftCardCoversBalance = !!(giftCard === null || giftCard === void 0 ? void 0 : giftCard.balance) && giftCard.balance > ((_a = balance === null || balance === void 0 ? void 0 : balance.remainingBalance) !== null && _a !== void 0 ? _a : 0);
    const canBalanceBePaid = !!paymentMethod || giftCardCoversBalance;
    return {
        isLoading,
        setIsLoading,
        isErrorState,
        paymentComplete,
        setPaymentComplete,
        clearState,
        canBalanceBePaid,
        handleConfirmClick: handleConfirmClick(actionHelpers),
        calculateOrderTotal: calculateOrderTotal(actionHelpers),
        // Billing Info Context
        paymentIntentId,
        paymentProcessor,
        // Payment Form Content
        paymentMethod,
        giftCard,
        balance,
        setIsFormSubmitted,
    };
};
